import { Dialog, DialogTitle, DialogDescription, DialogBody, DialogActions } from '@/components/catalyst-ui/dialog'
import { Button } from '@/components/catalyst-ui/button'
import { Input } from '@/components/catalyst-ui/input'
import { PlusIcon, XMarkIcon } from '@heroicons/react/24/solid'

export default function EditNameserversDialog({
  open,
  onClose,
  domainName,
  nameservers,
  onNameserverChange,
  onAddNameserver,
  onRemoveNameserver,
  onSave,
  isLoading = false,
}) {
  if (!nameservers) return null

  return (
    <Dialog open={open} onClose={onClose} className="!rounded-xl p-5 !bg-[#FAFAFA]">
      <div className="flex items-center justify-between">
        <DialogTitle className="!text-lg !font-semibold !text-[#09090B]">Edit Nameservers</DialogTitle>
        <button
          onClick={onClose}
          className="text-black hover:text-zinc-600 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 rounded-full"
        >
          <XMarkIcon className="w-5 h-5 -mt-6 -mr-2.5" />
        </button>
      </div>
      <DialogBody className="!mt-2">
        <DialogDescription className="!text-sm !font-medium !text-[#A1A1AA]">
          Update the nameservers for {domainName}. At least one nameserver is required.
        </DialogDescription>
        <div className="space-y-4 mt-4">
          {nameservers.map((ns, index) => (
            <div key={index} className="flex items-center gap-2">
              <Input
                type="text"
                value={ns}
                onChange={(e) => onNameserverChange(index, e.target.value)}
                placeholder={`Nameserver ${index + 1}`}
                className="flex-1"
              />
              {nameservers.length > 1 && (
                <Button 
                  onClick={() => onRemoveNameserver(index)}
                  outline
                  className="px-3 py-2 shrink-0 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 !text-[#B91C1C]"
                >
                  Remove
                </Button>
              )}
            </div>
          ))}
          <Button 
            onClick={onAddNameserver}
            outline
            className="w-full data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
          >
            <PlusIcon className="w-4 h-4 mr-2" />
            Add Nameserver
          </Button>
        </div>
      </DialogBody>
      <DialogActions className="!mt-4 !flex !flex-col sm:!flex-row !gap-3">
        <Button 
          onClick={onClose}
          outline
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          Cancel
        </Button>
        <Button 
          onClick={onSave}
          color="dark"
          disabled={isLoading}
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
